// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ciwhr_ZsOKmwtYWZh2QM {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.z4YHgjAXCsH0aj3PcI3f {
  overflow-y: auto;
  max-height: 70%;
  height: fit-content;
}

.QAaQQXVKfvtgKRKvJmfp {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 500px;
}

.ZbPKT74dVnfU_i_hgZK_ {
  width: 48px;
  height: 48px;
}

.PXdLgHyg_2hFidejBfQ6 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.OhUhts_Dbcc6pDjlI2Tw {
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.OhUhts_Dbcc6pDjlI2Tw:hover {
  color: rgba(214, 40, 40, 0.7);
}`, "",{"version":3,"sources":["webpack://./src/screens/UserAdministration/NotificationAdministration.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,gCAAA;AACF;AAAE;EACE,6BAAA;AAEJ","sourcesContent":[".notificationAdministrationContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 32px;\r\n}\r\n\r\n.notificationTable {\r\n  overflow-y: auto;\r\n  max-height: 70%;\r\n  height: fit-content;\r\n}\r\n\r\n.loadingContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  min-height: 500px;\r\n}\r\n\r\n.notificationImage {\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n\r\n.notificationAdministrationFooter {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.trashIcon {\r\n  cursor: pointer;\r\n  transition: all 0.1s ease-in-out;\r\n  &:hover {\r\n    color: rgba(214, 40, 40, 0.7);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationAdministrationContainer": `ciwhr_ZsOKmwtYWZh2QM`,
	"notificationTable": `z4YHgjAXCsH0aj3PcI3f`,
	"loadingContainer": `QAaQQXVKfvtgKRKvJmfp`,
	"notificationImage": `ZbPKT74dVnfU_i_hgZK_`,
	"notificationAdministrationFooter": `PXdLgHyg_2hFidejBfQ6`,
	"trashIcon": `OhUhts_Dbcc6pDjlI2Tw`
};
export default ___CSS_LOADER_EXPORT___;
